import { Observable } from 'rxjs';
import {CanDeactivateFn} from "@angular/router";

export interface DeactivateGuard {
  // Method that the component must implement to check for unsaved changes.
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<DeactivateGuard> = (
  component: DeactivateGuard
) => {
  if (component.canDeactivate) {
    const result = component.canDeactivate();

    if (result === false) {
      return confirm('WARNING: You have unsaved changes. Press OK to discard changes and leave, or Cancel to stay.');
    }
  }

  return true;
};
